import PropTypes from 'prop-types';
import { formatPrice } from '@spotahome/soyuz-currency';

const BY_MONTH_PRICE_TYPE = 'byMonth';

const isSeasonalPrice = priceType => priceType === BY_MONTH_PRICE_TYPE;

const defaultSeasonalPriceFormat = (seasonalPrice, currencyCode) =>
  `${seasonalPrice.min}-${formatPrice(seasonalPrice.max, currencyCode)}`;

const EMPTY_OBJECT = {};
const defaultSeasonalPrice = {
  min: 0,
  max: 0
};

const Themed = ({
  amount = 0,
  currencyCode = 'EUR',
  i18n = EMPTY_OBJECT,
  theme = EMPTY_OBJECT,
  seasonalPrice = defaultSeasonalPrice,
  type,
  isSeasonalPriceFeatureOn = false,
  monthly = true,
  seasonalPriceFormat = defaultSeasonalPriceFormat
}) =>
  isSeasonalPriceFeatureOn ? (
    <div className={theme.wrapper}>
      {!isSeasonalPrice(type) && !isSeasonalPriceFeatureOn && (
        <span className={theme.from}>{i18n.from}</span>
      )}
      <span className={theme.price}>
        {isSeasonalPrice(type) && !!seasonalPrice
          ? seasonalPriceFormat(seasonalPrice, currencyCode)
          : formatPrice(amount, currencyCode)}
      </span>
      <span className={theme.priceMonthly}>/{i18n.perMonth}</span>
    </div>
  ) : (
    <div className={theme.wrapper} data-test="priceContainer">
      {isSeasonalPrice(type) && <span className={theme.from}>{i18n.from}</span>}
      <span className={theme.price}>{formatPrice(amount, currencyCode)}</span>
      {monthly && <span className={theme.priceMonthly}>/{i18n.perMonth}</span>}
    </div>
  );

const propTypes = {
  type: PropTypes.string.isRequired,
  amount: PropTypes.number,
  currencyCode: PropTypes.string,
  seasonalPrice: PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number
  }),
  monthly: PropTypes.bool,
  seasonalPriceFormat: PropTypes.func
};

Themed.propTypes = {
  ...propTypes,
  i18n: PropTypes.shape({
    from: PropTypes.string,
    perMonth: PropTypes.string
  }),
  theme: PropTypes.shape({
    currency: PropTypes.string,
    price: PropTypes.string,
    priceMonthly: PropTypes.string,
    wrapper: PropTypes.string
  })
};
export { propTypes };
export default Themed;
